(() => {
  if (window.tenMilesRevenueBound) return;
  window.tenMilesRevenueBound = true;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const buttons = [...root.querySelectorAll('[data-revenue-stage]')];
    const descriptions = [...root.querySelectorAll('[data-revenue-description]')];
    const play = root.querySelector('[data-revenue-play]');
    const detail = root.querySelector('[data-revenue-detail]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, timer = null;
    if (!buttons.length) return;
    function select(index) {
      active = index;
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      root.querySelector('[data-revenue-counter]').textContent = String(index + 1).padStart(2, '0');
      root.querySelector('[data-revenue-title]').textContent = buttons[index].children[1].textContent;
      root.querySelector('[data-revenue-copy]').textContent = descriptions[index].textContent;
    }
    function stop() { clearInterval(timer); timer = null; play.textContent = motion.matches ? 'المرحلة التالية ←' : 'شغّل الرحلة ←'; play.setAttribute('aria-pressed', 'false'); }
    buttons.forEach((button, i) => button.addEventListener('click', () => { stop(); select(i); }));
    play.addEventListener('click', () => {
      if (motion.matches) { select((active + 1) % buttons.length); return; }
      if (timer) { stop(); return; }
      if (active === buttons.length - 1) select(0);
      play.textContent = 'أوقف العرض'; play.setAttribute('aria-pressed', 'true');
      timer = setInterval(() => {
        if (active >= buttons.length - 1) { stop(); return; }
        select(active + 1);
        if (active === buttons.length - 1) stop();
      }, 3200);
    });
    const onVisibility = () => { if (document.hidden) stop(); };
    document.addEventListener('visibilitychange', onVisibility);
    const onMotion = () => stop(); motion.addEventListener('change', onMotion);
    let viewObserver;
    if ('IntersectionObserver' in window) {
      viewObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); });
      viewObserver.observe(root.querySelector('.tm-revenue__journey'));
    }
    let revealObserver;
    if (!motion.matches && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('is-pending'); revealObserver.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('.tm-revenue__pillar').forEach((pillar, i) => { pillar.classList.add('is-pending'); pillar.style.transitionDelay = `${i * 90}ms`; revealObserver.observe(pillar); });
    }
    select(0); stop(); root.classList.add('is-enhanced'); detail.hidden = false; play.hidden = false;
    instances.set(root, () => { stop(); viewObserver?.disconnect(); revealObserver?.disconnect(); document.removeEventListener('visibilitychange', onVisibility); motion.removeEventListener('change', onMotion); });
  }
  function scan(scope) { scope.querySelectorAll('[data-revenue-system]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-revenue-system]').forEach(root => { instances.get(root)?.(); instances.delete(root); }));
})();
